<div class="box" *ngIf="elementIds">
  <div class="label" *ngIf="isGrouping">
    {{Title}}
  </div>
  <div *ngIf="itemsLocal">
    <div *ngFor="let item of itemsLocal;index as idx" class="row styled_row freeze_col">
      <div class="col-5" *ngIf="!isGrouping" style="text-align:right;">
        <app-label [Text]="Title + ' ' + (idx+1)"></app-label>
      </div>
      <div [ngClass]="isGrouping ? 'col-12' : 'col-7'">
        <div [ngClass]="item.value ? 'en' : ''">
          <button *ngIf="isEnableDeleteOption"
            [disabled]="!(item && item.value && item.value.toString().trim().length > 0)"
            class="button_icon icon_adjust" title="{{localService.languageContent.common.cancel}}"
            (click)="onDelete(idx)" style="color: indianred;">
            cancel
          </button>
          <input autocomplete="off" [id]="elementIds.txt_value + idx" type="number"
            *ngIf="isOnlyNumbers && numericConfig" [(ngModel)]="item.value" (input)="onInput(item.value)"
            (keypress)="localService.isNumberOnly($event,numericConfig)" (blur)="onFocusOut()" style="text-align:left;"
            placeholder="{{Title + ' ' + (idx+1)}}" title="{{Title + ' ' + (idx+1)}}" />
          <input autocomplete="off" [id]="elementIds.txt_value + idx" type="text" *ngIf="!isOnlyNumbers"
            [(ngModel)]="item.value" (input)="onInput(item.value)" maxlength="50" (blur)="onFocusOut()"
            placeholder="{{Title + ' ' + (idx+1)}}" title="{{Title + ' ' + (idx+1)}}" />
        </div>
      </div>
    </div>
  </div>
</div>